var map = {
	"./android_browser.png": 27748,
	"./brave.png": 71924,
	"./browsers-icons.png": 51570,
	"./chrome.png": 77330,
	"./chrome_mobile.png": 28890,
	"./firefox.png": 56542,
	"./firefox_for_ios.png": 4537,
	"./firefox_mobile.png": 89103,
	"./iexplorer.png": 54501,
	"./macos-client.png": 62152,
	"./microsoft_edge.png": 72586,
	"./opera.png": 75824,
	"./opera_mobile.png": 56187,
	"./palemoon.png": 76313,
	"./postman.png": 29342,
	"./safari.png": 81550,
	"./samsung_internet.png": 56247,
	"./skyflok-macos-client.png": 11639,
	"./skyflok-windows-client.png": 19760,
	"./test_client_name.png": 52744
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65522;